<template>
  <div class="count-down-component"
       :class="[
         { 'is-text-bold': textBold },
       ]"
  >
    <img class="count-down-bg-img"
         :src="blockBgImg"
         alt="倒计时背景"
    />
    <div class="count-down-desc"
         :style="descStyle"
    >
      {{ desc }}
    </div>
    <div class="count-down-content"
         :style="contentStyle"
    >
      <div class="count-down-time--left"
           :style="pcItemStyle"
      >
        {{ leftText }}
      </div>
      <div class="count-down-time">
        <div v-if="showDays"
             class="count-down-time-item"
             :style="pcItemStyle"
        >
          <div class="count-down-time-num"
               :style="itemStyle"
          >
            {{ timerData.days[0] }}
          </div>
          <div class="count-down-time-num"
               :style="itemStyle"
          >
            {{ timerData.days[1] }}
          </div>
          <div class="count-down-time-unit"
               :style="pcItemStyle"
          >
            天
          </div>
        </div>
        <div class="count-down-time-item"
             :style="pcItemStyle"
        >
          <div class="count-down-time-num"
               :style="itemStyle"
          >
            {{ timerData.hours[0] }}
          </div>
          <div class="count-down-time-num"
               :style="itemStyle"
          >
            {{ timerData.hours[1] }}
          </div>
          <div class="count-down-time-unit"
               :style="pcItemStyle"
          >
            时
          </div>
        </div>
        <div class="count-down-time-item"
             :style="pcItemStyle"
        >
          <div class="count-down-time-num"
               :style="itemStyle"
          >
            {{ timerData.minutes[0] }}
          </div>
          <div class="count-down-time-num"
               :style="itemStyle"
          >
            {{ timerData.minutes[1] }}
          </div>
          <div class="count-down-time-unit"
               :style="pcItemStyle"
          >
            分
          </div>
        </div>
        <div v-if="!showDays"
             class="count-down-time-item"
             :style="pcItemStyle"
        >
          <div class="count-down-time-num"
               :style="itemStyle"
          >
            {{ timerData.seconds[0] }}
          </div>
          <div class="count-down-time-num"
               :style="itemStyle"
          >
            {{ timerData.seconds[1] }}
          </div>
          <div class="count-down-time-unit"
               :style="pcItemStyle"
          >
            秒
          </div>
        </div>
      </div>
      <div class="count-down-time--right"
           :style="pcItemStyle"
      >
        {{ rightText }}
      </div>
    </div>
  </div>
</template>

<script>
  import CountDown from '@/utils/count-down';
  import { pxToVw, isPC } from '@/utils';

  export default {
    name: 'CountDown',
    data() {
      return {
        timerData: {
          days: '00',
          hours: '00',
          minutes: '00',
          seconds: '00',
        },
      };
    },
    props: {
      desc: String,
      descTop: {
        type: Number,
        default: 16,
      },
      descFontSize: {
        type: Number,
        default: 36,
      },
      descBold: Boolean,
      start: {
        type: Number,
        required: true,
      },
      end: {
        type: Number,
        required: true,
      },
      blockBgImg: {
        type: String,
        required: true,
      },
      itemBgImg: {
        type: String,
      },
      numColor: {
        type: String,
      },
      textColor: {
        type: String,
      },
      itemBottom: {
        type: Number,
        default: 30,
      },
      leftText: {
        type: String,
        default: '仅剩',
      },
      rightText: String,
      horizonRightOffset: {
        type: Number,
      },
      textBold: Boolean,
      itemWidth: Number,
      itemHeight: Number,
    },
    computed: {
      isIframe() {
        return window.location !== window.top.location;
      },
      showDays() {
        return parseInt(this.timerData.days, 10) > 0;
      },
      inPCPlatform() {
        return isPC();
      },
      descStyle() {
        const res = {};
        res.top = `${pxToVw(this.descTop)}vw`;
        res.fontSize = `${pxToVw(this.descFontSize)}vw`;
        if (this.descBold) {
          res.fontBlod = 'bold';
        }
        return res;
      },
      itemStyle() {
        const result = {};
        result.background = this.itemBgImg ? `url('${this.itemBgImg}') no-repeat` : '#fff';
        result['background-size'] = 'contain';
        if (this.numColor) {
          result.color = this.numColor;
        }
        if (!this.isIframe && this.inPCPlatform) {
          result.width = '2.8vw';
        } else if (this.itemWidth) {
          result.width = `${pxToVw(this.itemWidth)}vw`;
        } else {
          result.width = `${pxToVw(60)}vw`;
        }
        if (!this.isIframe && this.inPCPlatform) {
          result.height = '4vw';
        } else if (this.itemHeight) {
          result.height = `${pxToVw(this.itemHeight)}vw`;
        } else {
          result.height = `${pxToVw(92)}vw`;
        }
        if (!this.isIframe && this.inPCPlatform) {
          result['font-size'] = '3vw';
          result['margin-right'] = '0.3vw';
          result['border-radius'] = '0.5vw';
        }
        return result;
      },
      contentStyle() {
        const style = {};
        style.color = this.textColor ? this.textColor : '#222';
        if (!this.isIframe && this.inPCPlatform) {
          style.bottom = '20%';
        } else {
          style.bottom = `${pxToVw(this.itemBottom)}vw`;
        }
        style['padding-right'] = `${pxToVw(this.horizonRightOffset)}vw`;
        return style;
      },
      pcItemStyle() {
        const style = {};
        if (!this.isIframe && this.inPCPlatform) {
          style['font-size'] = '1.5vw';
          style['margin-right'] = '0.25vw';
        }
        return style;
      },
    },
    methods: {
      initCountDown() {
        new CountDown({
          startTime: this.start,
          endTime: this.end,
          render: (data) => {
            this.timerData = data;
          },
          end: () => {
            this.$emit('count-down-ended');
          },
        });
      },
    },
    created() {
      this.initCountDown();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  @count-down-string-padding: @size-extra-small;
  @count-down-item-margin: @size-base/2;

  .count-down {
    &-component {
      line-height: 1;
      position: relative;

      &.is-text-bold {
        font-weight: bold;
      }
    }

    &-bg-img {
      display: block;
      width: 100%;
    }

    &-desc {
      position: absolute;
      left: 50%;
      transform: translate3d(-50%, 0, 0);
    }

    &-content {
      width: 100%;
      box-sizing: border-box;
      position: absolute;
      left: 0;
      display: flex;
      align-items: flex-end;
      justify-content: center;
    }

    &-time {
      display: flex;
      align-items: center;
      justify-content: center;

      &--left,
      &--right {
        padding-bottom: @count-down-string-padding;
      }

      &--left {
        margin-right: @count-down-item-margin;
      }

      &-item {
        display: flex;
        align-items: flex-end;
        font-size: @font-size-base;
        color: @color-black-light;
        position: relative;
        z-index: 2;

        &:not(:last-child) {
          margin-right: @count-down-item-margin;
        }
      }

      &-num {
        margin-right: @size-extra-small;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        border-radius: @border-radius-normal;
        color: @color-black-light;
        background-size: contain;
        font-size: 60px;
        font-weight: @font-weight-bold;
      }

      &-unit {
        padding-bottom: @count-down-string-padding;
      }
    }
  }
</style>
